const Constants = {
  urls: {
    settings: {
      WATERMARKS: 'app.settings.watermarks',
      PROPERTIES: 'app.settings.metadata',
      DOCUMENT_TYPES: 'app.settings.types',
      FOLDER_TYPES: 'app.settings.folderTypes',
      WORKFLOW_TYPES: 'app.settings.crTypes',
      FOLDER_STRUCTURE_TYPES: 'app.settings.folderStructureTemplateTypes'
    }
  },
  eos: {
    activity: {
      SUMMARY: 'SUMMARY',
      DETAILED: 'DETAILED',
      WORKFLOW: 'WORKFLOW',
      USER_ACCESS: 'USER_ACCESS',
      DOWNLOAD: 'DOWNLOAD',
      ACKNOWLEDGEMENT: 'ACKNOWLEDGEMENT'
    },
    downloadStatus: {
      ALL: 'ALL',
      OCCURRED: 'OCCURRED',
      NOT_OCCURRED: 'NOT_OCCURRED'
    },
    acknowledgementStatus: {
      ALL: 'ALL',
      NOT_STARTED: 'NOT_STARTED',
      IN_PROGRESS: 'IN_PROGRESS',
      COMPLETED: 'COMPLETED'
    },
    CONFIG_METHOD: {
      APP: 'app',
      BULK: 'bulk'
    },
    CONFIG_LEVEL: {
      SITE: 'SITE',
      STUDY: 'STUDY',
      COUNTRY: 'COUNTRY'
    },
    WF_CONFIG_LEVEL: {
      STUDY_SITE: 'Study/Site',
      COUNTRY: 'Country'
    }
  },
  etmf: {
    FILE_PLAN: 'FILE_PLAN',
    PACKAGES: 'PACKAGES',
    masterData: {
      type: {
        PRODUCT: 'PRODUCT',
        ENVIRONMENT: 'ENVIRONMENT',
        TRIAL: 'TRIAL',
        STUDY: 'STUDY',
        COUNTRY: 'COUNTRY',
        SITE: 'SITE'
      }
    },
    property: {
      ARTIFACT: 'ARTIFACT',
      MILESTONE: 'MILESTONE'
    },
    level: {
      PRODUCT: 'PRODUCT',
      STUDY: 'STUDY',
      ENVIRONMENT: 'ENVIRONMENT',
      COUNTRY: 'COUNTRY',
      SITE: 'SITE'
    }
  },
  system: {
    clinicalApp: {
      RCM: 'RCM',
      RACT: 'RACT',
      SIM: 'SIM',
      ETMF: 'ETMF',
      IMEDIDATA: 'IMEDIDATA',
      PLINTH: 'PLINTH'
    },
    justificationTypes: {
      JUSTIFICATION_CHANGE: 'JUSTIFICATION_CHANGE',
      JUSTIFICATION_REJECT: 'JUSTIFICATION_REJECT'
    },
    messageTypes: {
      ADMIN_ACTION: 'ADMIN_ACTION',
      READ_AND_ACKNOWLEDGEMENT: 'READ_AND_ACKNOWLEDGEMENT',
      DOCUMENT_MIGRATION: 'DOCUMENT_MIGRATION',
      MIGRATIONS_WITOUT_CR: 'MIGRATIONS_WITOUT_CR',
      APPROVALS: 'APPROVALS',
      CERTIFIED_COPY: 'CERTIFIED_COPY',
      QC_REVIEW: 'QC_REVIEW'
    },
    authTypes: {
      RCM: 'RCM',
      IMEDIDATA: 'IMEDIDATA',
      OKTA: 'OKTA',
      CHECKMATE: 'CHECKMATE'
    },
    language: {
      ENGLISH: 'en-us',
      JAPAN: 'ja'
    },
    fallbackLanguage: 'en-US',
    settings: {
      folderType: {
        documentTypesAllowed: {
          ALL: 'ALL',
          DEFINED_IN_CREATION: 'DEFINED_IN_CREATION',
          DEFINED_ON_FOLDER: 'DEFINED_ON_FOLDER'
        }
      },
      entity: {
        USER: 'USER',
        GROUP: 'GROUP',
        FOLDER_TYPE: 'FOLDER_TYPE',
        FOLDER_TYPE_TEMPLATE: 'FOLDER_TYPE_TPL',
        FOLDER_STRUCTURE_TEMPLATE_TYPE: 'FOLDER_STRUCTURE_TEMPLATE_TYPE',
        FOLDER_STRUCTURE_TYPE: 'FOLDER_STRUCTURE_TYPE',
        DOCUMENT_TYPE: 'DOCUMENT_TYPE',
        DOCUMENT_TYPE_TEMPLATE: 'DOCUMENT_TYPE_TPL',
        METADATA: 'METADATA',
        METADATA_TEMPLATE: 'METADATA_TPL',
        PROPERTY: 'PROPERTY',
        WATERMARK: 'WATERMARK',
        JUSTIFICATION: 'JUSTIFICATION',
        TEXT_MESSAGE: 'TEXT_MESSAGE',
        MESSAGE: 'MESSAGE',
        WORKFLOW_TEMPLATE: 'WORKFLOW_TEMPLATE',
        FST_TYPE: 'FST_TYPE'
      },
      entities: {
        USERS: 'USERS',
        GROUPS: 'GROUPS',
        FOLDER_TYPES: 'FOLDER_TYPES',
        FOLDER_STRUCTURE_TEMPLATE_TYPES: 'FOLDER_STRUCTURE_TEMPLATE_TYPES',
        FOLDER_STRUCTURE_TYPES: 'FOLDER_STRUCTURE_TYPES',
        DOCUMENT_TYPES: 'DOCUMENT_TYPES',
        WORKFLOW_TEMPLATES: 'WORKFLOW_TEMPLATES',
        METADATAS: 'METADATAS',
        PROPERTIES: 'PROPERTIES',
        WATERMARKS: 'WATERMARKS',
        JUSTIFICATIONS: 'JUSTIFICATIONS',
        REASONS_FOR_REJECTION: 'REASONS_FOR_REJECTION',
        TASK_TEAM_STEP_LABELS: 'TASK_TEAM_STEP_LABELS',
        TEXTS_MESSAGES: 'TEXTS_MESSAGES',
        MESSAGES: 'MESSAGES'
      },
      integration: {
        NONE: 'INTEGRATION_EDITOR_NONE',
        GOOGLE_DRIVE: 'INTEGRATION_EDITOR_GOOGLE_DRIVE',
        OFFICE_365: 'INTEGRATION_EDITOR_OFFICE_365'
      },
      integrations: {
        NONE: 'NONE',
        GDRIVE: 'GDRIVE',
        OFFICE: 'OFFICE'
      }
    },
    saveFilterType: {
      ACTIVITY: 'ACTIVITY',
      CLINICAL: 'CLINICAL',
      ETMF: 'ETMF',
      ACCESS_RIGHTS: 'ACCESS_RIGHTS',
      READ_AND_ACKNOWLEDGE: 'READ_AND_ACKNOWLEDGE',
      REJECT: 'REJECT',
      USER: 'USER2',
      GROUP: 'GROUP',
      CHANGE_REQUEST: 'CHANGE_REQUEST',
      CHANGE_REQUEST_TYPES: 'CHANGE_REQUEST_TYPES',
      PROPERTIES_SEARCH: 'PROPERTIES_SEARCH',
      ETMF_COMPLETION_RATE: 'ETMF_COMPLETION_RATE',
      ETMF_DOCUMENT_DETAIL: 'ETMF_DOCUMENT_DETAIL',
      ETMF_FINAL_DOCS: 'ETMF_FINAL_DOCS',
      ETMF_CONTRIBUTOR_DOC_STATUS: 'ETMF_CONTRIBUTOR_DOC_STATUS',
      PROPERTIES_USAGE: 'PROPERTIES_USAGE',
      EOS_DOWNLOAD_ACTIVITY: 'EOS_DOWNLOAD_ACTIVITY',
      EOS_ACKNOWLEDGEMENT_ACTIVITY: 'EOS_ACKNOWLEDGEMENT_ACTIVITY',
      EOS_WORKFLOWS: 'EOS_WORKFLOWS',
      TASK: 'TASK',
      DOCUMENT_EXPIRED: 'DOCUMENT_EXPIRED',
      CUSTOM: 'CUSTOM',
      SEARCH: 'SEARCH',
      EOS_WORKFLOWS_REQUESTS: 'EOS_WORKFLOWS_REQUESTS',
      DUPLICATE_DOCS: 'DUPLICATE_DOCS',
      ETMF_TIMELINESS: 'ETMF_TIMELINESS'
    },
    status: {
      NORMAL: 'NORMAL',
      MAINTENANCE_MODE: 'MAINTENANCE_MODE'
    }
  },
  activityLog: {
    type: {
      ACL: 'ACL',
      DOCUMENT: 'DOCUMENT',
      WORKFLOW: 'WORKFLOW',
      TASK: 'TASK'
    }
  },
  search: {
    type: {
      ALL: 'ALL',
      DOC_UID: 'DOC_UID',
      CONTENT: 'CONTENT',
      FILE_NAME: 'FILE_NAME',
      FILE_PATH: 'FILE_PATH',
      METADATA_VALUE: 'METADATA_VALUE'
    }
  },
  user: {
    roles: {
      ADMIN: 'ADMIN',
      CONTENT_ADMIN: 'CONTENT_ADMIN',
      POWER_USER: 'POWER_USER',
      USER: 'USER',
      AUDITOR: 'AUDITOR',
      INSPECTOR: 'INSPECTOR',
      EXTERNAL: 'EXTERNAL',
      CLOUD_ADMIN_ROLE: 'CLOUD_ADMIN_ROLE',
      RCR_USER: 'RCR_USER',
      ETMF_MANAGER: 'ETMF_MANAGER',
      ETMF_SPECIALIST: 'ETMF_SPECIALIST',
      ETMF_SITE_USER: 'ETMF_SITE_USER',
      ETMF_STUDY_USER: 'ETMF_STUDY_USER',
      EOS_SITE_USER: 'EOS_SITE_USER',
      ETMF_SPONSOR: 'ETMF_SPONSOR',
      STUDY_ADMIN: 'STUDY_ADMIN'
    },
    permissions: {
      manage_etmf: 'manage_etmf',
      manage_study_etmf: 'manage_study_etmf',
      upload_site_artifact: 'upload_site_artifact',
      access_study_staging_area: 'access_study_staging_area',
      access_rave_content_repository: 'access_rave_content_repository',
      full_rcr_document: 'full_rcr_document',
      read_rcr_document: 'read_rcr_document',
      view_study_etmf: 'view_study_etmf'
    },
    systemHelperType: {
      USER: 'USER',
      GROUP: 'GROUP'
    },
    authType: {
      RCM: 'RCM',
      OKTA: 'OKTA',
      CHECKMATE: 'CHECKMATE',
      IMEDIDATA: 'IMEDIDATA'
    },
    accountType: {
      SSO: 'SSO',
      SERVICE: 'SERVICE',
      RCM: 'RCM'
    }
  },
  group: {
    type: {
      USER_DEFINED: 'USER_DEFINED',
      SYSTEM: 'SYSTEM',
      CLOUDADMIN_ACL: 'CLOUDADMIN_ACL'
    }
  },
  metadata: {
    type: {
      SELECT_ONE_USER: 'SELECT_ONE_USER',
      SELECT_MULTI_USER: 'SELECT_MULTI_USER',
      SELECT_ONE_GROUP: 'SELECT_ONE_GROUP',
      SELECT_MULTI_GROUP: 'SELECT_MULTI_GROUP',
      ARTIFACT: 'ARTIFACT',
      DATETIME: 'DATETIME',
      STRING: 'STRING',
      NUMBER: 'NUMBER',
      SELECT_ONE: 'SELECT_ONE',
      SELECT_MULTI: 'SELECT_MULTI'
    }
  },
  workflow: {
    processingType: {
      SERIAL: 'SERIAL',
      PARALLEL: 'PARALLEL',
      N_OF_ALL: 'N_OF_ALL'
    },
    type: {
      NEW: 'NEW',
      CHANGE: 'CHANGE',
      OBSOLETE: 'OBSOLETE',
      OBSOLETE_REFERENCE: 'OBSOLETE_REFERENCE',
      OBSOLETE_PLACEHOLDER: 'OBSOLETE_PLACEHOLDER',
      TRAINING: 'TRAINING',
      IMPORT: 'IMPORT',
      CREATE_REFERENCE: 'CREATE_REFERENCE',
      CREATE_PLACEHOLDER: 'CREATE_PLACEHOLDER',
      FILL_PLACEHOLDER: 'FILL_PLACEHOLDER',
      FILE_ARTIFACT: 'FILE_ARTIFACT',
      RECLASSIFY_DOCUMENT: 'RECLASSIFY_DOCUMENT',
      EOS: 'EOS',
      EOS_DOWNLOAD_AND_ACKNOWLEDGE: 'EOS_DOWNLOAD_AND_ACKNOWLEDGE',
      QC_REVIEW: 'QC_REVIEW'
    },
    step: {
      status: {
        DONE: 'DONE',
        ACTIVE: 'ACTIVE'
      },
      type: {
        AUTHORIZE_PLACEHOLDER_CREATION: 'AUTHORIZE_PLACEHOLDER_CREATION',
        AUTHORIZE_REFERENCE_CREATION: 'AUTHORIZE_REFERENCE_CREATION',
        AUTHORIZE_MIGRATION: 'AUTHORIZE_MIGRATION',
        AUTHORIZE_FILL_PLACEHOLDER: 'AUTHORIZE_FILL_PLACEHOLDER',
        AUTHORIZE_RECLASSIFICATION: 'AUTHORIZE_RECLASSIFICATION',
        AUTHORIZE_CHANGE_REQUEST: 'AUTHORIZE_CHANGE_REQUEST',
        APPROVE_OBSOLETE: 'APPROVE_OBSOLETE',
        DOWNLOAD_EOS: 'DOWNLOAD_EOS',
        REVISE_EDIT: 'REVISE_EDIT',
        REVISE_EDIT_MULTIFILE: 'REVISE_EDIT_MULTIFILE',
        REVISE_EDIT_EOS: 'REVISE_EDIT_EOS',
        REVISE_EDIT_MIGRATION: 'REVISE_EDIT_MIGRATION',
        APPROVE_REFERENCE_CREATION: 'APPROVE_REFERENCE_CREATION',
        APPROVE_PLACEHOLDER_CREATION: 'APPROVE_PLACEHOLDER_CREATION',
        APPROVE_OBSOLETING_REFERENCE: 'APPROVE_OBSOLETING_REFERENCE',
        REVISE_EDIT_RECLASSIFICATION: 'REVISE_EDIT_RECLASSIFICATION',
        REVISE_EDIT_FILE_ARTIFACT: 'REVISE_EDIT_FILE_ARTIFACT',
        ACKNOWLEDGE_EOS: 'ACKNOWLEDGE_EOS',
        REVIEW: 'REVIEW',
        REVIEW_MULTIFILE: 'REVIEW_MULTIFILE',
        REVIEW_EOS: 'REVIEW_EOS',
        REVIEW_RECLASSIFICATION: 'REVIEW_RECLASSIFICATION',
        REVIEW_FILE_ARTIFACT: 'REVIEW_FILE_ARTIFACT',
        APPROVE_MULTIFILE: 'APPROVE_MULTIFILE',
        APPROVE_MIGRATION: 'APPROVE_MIGRATION',
        APPROVE: 'APPROVE',
        APPROVE_EOS: 'APPROVE_EOS',
        APPROVE_RECLASSIFICATION: 'APPROVE_RECLASSIFICATION',
        APPROVE_FILE_ARTIFACT: 'APPROVE_FILE_ARTIFACT',
        TRAINING: 'TRAINING'
      }
    },
    status: {
      ACTIVE: 'ACTIVE',
      FINISHED: 'FINISHED',
      SUSPENDED: 'SUSPENDED',
      CANCELLED: 'CANCELLED'
    },
    patchUrlAction: {
      suspend: 'suspend',
      cancel: 'cancel',
      resume: 'resume'
    },
    viewType: {
      active: 'active',
      finished: 'finished',
      all: 'all'
    }
  },
  file: {
    // Dynamic thumbnail URL - reads from HTML attribute set by backend (matches legacy app behavior)
    // Legacy: angular.element('html').attr('thumbnail-url')
    // Falls back to default if attribute not found
    thumbnailUrl:
      typeof document !== 'undefined'
        ? document.documentElement.getAttribute('thumbnail-url') || '/cdn/auth/thumbnails/'
        : '/cdn/auth/thumbnails/',
    acl: {
      NONE: 'NONE',
      BROWSE: 'BROWSE',
      VIEW: 'VIEW',
      READ: 'READ',
      WRITE: 'WRITE',
      DELETE: 'DELETE'
    },
    systemFolderType: {
      WORKFLOWS: 'WORKFLOWS',
      REGULATED_CONTENT: 'REGULATED_CONTENT',
      TEMPLATES: 'TEMPLATES',
      FORMS: 'FORMS',
      CONTAMINATED: 'CONTAMINATED',
      UPLOAD: 'UPLOAD',
      REPORTS: 'REPORTS',
      SYSTEM_DOCUMENTS: 'SYSTEM_DOCUMENTS',
      EMAIL_UPLOADS: 'EMAIL_UPLOADS',
      INIT_ETMF_FILES: 'INIT_ETMF_FILES',
      DOCUMENT_MIGRATIONS_AND_EXPORTS: 'DOCUMENT_MIGRATIONS_AND_EXPORTS',
      SETTINGS_AND_SYSTEM_EXPORTS_IMPORTS: 'SETTINGS_AND_SYSTEM_EXPORTS_IMPORTS'
    },
    folderFeatureType: {
      ETMF: 'ETMF',
      RCR: 'RCR'
    },
    type: {
      FOLDER: 'FOLDER',
      DOCUMENT: 'DOCUMENT',
      REFERENCE: 'REFERENCE',
      PLACEHOLDER: 'PLACEHOLDER'
    },
    lifecycleState: {
      APPROVED: 'APPROVED',
      DRAFT: 'DRAFT',
      EFFECTIVE: 'EFFECTIVE',
      HELPER_EXPIRING: 'HELPER_EXPIRING',
      COMPLETED: 'COMPLETED',
      EXPIRED: 'EXPIRED',
      OBSOLETE: 'OBSOLETE',
      REJECTED: 'REJECTED',
      RETIRED: 'RETIRED'
    },
    blindingStatus: {
      BLINDED: 'BLINDED',
      UNBLINDED: 'UNBLINDED'
    },
    referenceType: {
      DOCUMENT: 'DOCUMENT',
      FORM: 'FORM',
      AMENDMENT: 'AMENDMENT'
    },
    uuid: {
      REGULATED_CONTENT: 'RvldtQP-24a3e8bf-e3de-4d3a-a524-3fe0ace760ab',
      INIT_ETMF_FILES: '1eea09ee-9be6-4bdf-bb51-633f5b091104',
      FOLDER_STRUCTURE: 'WNIU4vI-ac877926-c7f7-4633-b615-8b218524d5c1',
      TEMPLATES: '2c75YHZ-ba234c5d-da99-40bd-af64-3a446e3dd08b'
    },
    upload: {
      compressionLevel: 9
    },
    prohibitedExtensions: {
      EXE: 'EXE',
      SH: 'SH'
    }
  },
  task: {
    taskType: {
      USER_REJECTED_TASK: 'USER_REJECTED_TASK',
      USER: 'USER'
    },
    status: {
      INACTIVE: 'INACTIVE',
      OPEN: 'OPEN',
      APPROVED: 'APPROVED',
      REJECTED: 'REJECTED',
      CANCELLED: 'CANCELLED',
      SUSPENDED: 'SUSPENDED'
    },
    viewType: {
      ME: 'me',
      ALL: 'all',
      COMPLETED: 'completed',
      ALL_OPENED: 'all-opened'
    }
  },
  reports: {
    reportType: {
      EMAIL_UPLOADS: 'EMAIL_UPLOADS',
      SETTINGS_AND_SYSTEM_EXPORTS_IMPORTS: 'SETTINGS_AND_SYSTEM_EXPORTS_IMPORTS',
      REPORTS: 'REPORTS',
      DOCUMENT_MIGRATIONS_AND_EXPORTS: 'DOCUMENT_MIGRATIONS_AND_EXPORTS'
    },
    reportTypesMap: {
      ACCESS_RIGHTS_REPORT: 'ACCESS_RIGHTS_REPORT',
      ACTIVITY_REPORT: 'ACTIVITY_REPORT',
      CHANGE_REQUEST_REPORT: 'CHANGE_REQUEST_REPORT',
      CHANGE_REQUEST_TYPES_REPORT: 'CHANGE_REQUEST_TYPES_REPORT',
      CLINICAL_REPORT: 'CLINICAL_REPORT',
      COMPLETION_AND_MISSING_DOCS_REPORT: 'COMPLETION_AND_MISSING_DOCS_REPORT',
      CONTRIBUTOR_DOC_STATUS_REPORT: 'CONTRIBUTOR_DOC_STATUS_REPORT',
      CUSTOM_REPORT: 'CUSTOM_REPORT',
      DOCUMENT_EXPIRED_REPORT: 'DOCUMENT_EXPIRED_REPORT',
      ETMF_DOCUMENT_DETAIL_REPORT: 'ETMF_DOCUMENT_DETAIL_REPORT',
      FINAL_DOCS_REPORT: 'FINAL_DOCS_REPORT',
      GROUP_MEMBERSHIP_REPORT: 'GROUP_MEMBERSHIP_REPORT',
      PROPERTIES_SEARCH_REPORT: 'PROPERTIES_SEARCH_REPORT',
      PROPERTIES_USAGE_REPORT: 'PROPERTIES_USAGE_REPORT',
      READ_AND_ACKNOWLEDGE_REPORT: 'READ_AND_ACKNOWLEDGE_REPORT',
      REJECT_REPORT: 'REJECT_REPORT',
      REPORTS: 'REPORTS',
      TASK_REPORT: 'TASK_REPORT',
      USERS_AND_USAGE_REPORT: 'USERS_AND_USAGE_REPORT'
    },
    level: {
      ALL: 'ALL',
      PRODUCT: 'PRODUCT',
      ENVIRONMENT: 'ENVIRONMENT',
      STUDY: 'STUDY',
      TRIAL: 'TRIAL',
      COUNTRY: 'COUNTRY',
      SITE: 'SITE'
    },
    docCompletionStatus: {
      ALL: 'ALL',
      NOT_STARTED: 'NOT_STARTED',
      IN_PROGRESS: 'IN_PROGRESS',
      COMPLETED: 'COMPLETED'
    },
    docCompletionStatusReverse: {
      COMPLETED: 'COMPLETED',
      IN_PROGRESS: 'IN_PROGRESS',
      NOT_STARTED: 'NOT_STARTED',
      ALL: 'ALL'
    },
    shared: {
      QC_REVIEW: 'QC_REVIEW'
    }
  },
  tags: {
    type: {
      ETMF: 'ETMF',
      NON_ETMF: 'NON_ETMF',
      REGULATORY_SUBMISSION: 'REGULATORY_SUBMISSION'
    }
  },
  folder: {
    name: {
      SITES: 'Sites',
      CLINICAL: 'Clinical',
      MEDIDATA: 'Medidata'
    }
  }
}

export default Constants
